export const PROPERTY_PUBLIC = Symbol('property:public');